// Single source of truth for cable product NAMES + COLORS, so every page
// (production launch, sales order, standard drum length, consumption standard,
// stranding calculator) shows the SAME options. Add a product/color here once
// and it propagates everywhere.

// Canonical full list (production launch + stranding calculator).
export const CABLE_NAMES = [
  'CYYF',
  'N2XH',
  'MYYM',
  'MYYUP',
  'CYABY',
  'CYABYF',
  'RVK',
  'MYF',
  'FY',
  'COPPER_ROPE_FLEXIBLE',
  'COPPER_ROPE_SOLID'
];

// Semi-finished intermediates — excluded from sales / standard pages.
export const COPPER_ROPE_NAMES = ['COPPER_ROPE_SOLID', 'COPPER_ROPE_FLEXIBLE'];

// Finished products only (sales order, standard drum length, consumption).
export const CABLE_NAMES_NO_ROPE = CABLE_NAMES.filter(
  n => !COPPER_ROPE_NAMES.includes(n)
);

// Canonical color options (matches the production "create new product" page).
export const CABLE_COLORS = [
  'BLACK',
  'BLUE',
  'BROWN',
  'GREEN-YELLOW',
  'GREY',
  'GREY 7004',
  'RED',
  'WHITE'
];
